/**
 * Is this build being DRIVEN rather than used?
 *
 * Recorded demos and e2e runs load the app with `tauriShim.js`, which stands in
 * for Tauri's `invoke` and therefore makes `isTauri()` true — deliberately, so
 * the app renders its desktop layout. The side effect is that every "am I a real
 * desktop install" check says yes, including the ones that report metrics. A
 * Playwright run then counts as an active device, and since it never signs in it
 * also lands in "local-only users" — inflating exactly the two numbers the
 * dashboard is for (owner, 22.09.2026).
 *
 * Nothing here is a security boundary. Anyone can set these and opt out of being
 * counted, which costs nothing: the counters are anonymous aggregates, so the
 * only thing a forger achieves is not being added up. It exists to keep our own
 * test traffic out of our own numbers.
 *
 * Two signals, deliberately:
 *   · `window.__demoIpc` — set by tauriShim, so every recorded demo and e2e run
 *     is covered without the harness remembering to do anything;
 *   · `REACT_APP_SYNTHETIC=1` — for a build that is driven WITHOUT the shim
 *     (a staging smoke test, a browser-target run), where nothing else marks it.
 */

/** True when this page is a demo recording, an e2e run, or an explicitly synthetic build. */
export function isSyntheticRun() {
  try {
    if (process.env.REACT_APP_SYNTHETIC === '1') return true;
    return typeof window !== 'undefined' && Boolean(window.__demoIpc);
  } catch {
    return false;
  }
}
